import { type } from 'ramda';
import { CONDITION_OPERATOR } from '../constants';

const { AND, OR, NOT } = CONDITION_OPERATOR;

const CONDITION_OBJECT_EVALUATOR = {
  [AND]: (conditions = [], props) =>
    conditions.reduce((acc, c) => acc && evaluateCondition(c, props), true),
  [OR]: (conditions = [], props) =>
    conditions.reduce((acc, c) => acc || evaluateCondition(c, props), false),
  [NOT]: ([condition = false] = [false], props) => !evaluateCondition(condition, props),
};

const evaluateConditionObject = ({ operator = AND, conditions = [] }, props) => {
  const evaluatorFn = CONDITION_OBJECT_EVALUATOR[operator];
  return evaluatorFn ? evaluatorFn(conditions, props) : true;
};

export const evaluateCondition = (condition, props) => {
  if (condition === undefined) {
    return true;
  }

  const conditionType = type(condition);
  switch (conditionType) {
    case 'Boolean':
      return condition;
    case 'String':
      return props[condition];
    case 'Array':
      return evaluateConditionObject({ operator: AND, conditions: condition }, props);
    case 'Object':
      return evaluateConditionObject(condition, props);
    case 'Function':
      return condition(props);
    default:
      return false;
  }
};
